/**
 * Fecha relativa sin librería: "hace 12 d", "hace 3 h", "hoy", "dentro de 2 días".
 * Entrada `rel-time` del catálogo (13/10/2026): nació en el Vault (vault-ui.tsx) y
 * se movió acá para que Partnerships ("actualizado hace 3 d") no importe UI del
 * Vault. Cuenta hacia adelante también: el vencimiento de un link temporal decía
 * "este minuto" cuando solo se contaba el pasado.
 */
export function fmtRelative(iso: string | null | undefined, lang = 'es'): string {
  if (!iso) return '—';
  const diff = Date.now() - new Date(iso).getTime();
  const sign = diff < 0 ? 1 : -1;
  const min = Math.floor(Math.abs(diff) / 60_000);
  const h = Math.floor(min / 60);
  const d = Math.floor(h / 24);
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });
  if (d >= 30) return rtf.format(sign * Math.floor(d / 30), 'month');
  if (d >= 1) return rtf.format(sign * d, 'day');
  if (h >= 1) return rtf.format(sign * h, 'hour');
  return rtf.format(sign * min, 'minute');
}
